/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { StreemApiSizeFromJSON, StreemApiSizeToJSON, } from './';
export function StreemRoomArTrackableDefinitionMarker2dFromJSON(json) {
    return StreemRoomArTrackableDefinitionMarker2dFromJSONTyped(json, false);
}
export function StreemRoomArTrackableDefinitionMarker2dFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'file': !exists(json, 'file') ? undefined : json['file'],
        'expectedSizeMeters': !exists(json, 'expected_size_meters') ? undefined : StreemApiSizeFromJSON(json['expected_size_meters']),
    };
}
export function StreemRoomArTrackableDefinitionMarker2dToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'file': value.file,
        'expected_size_meters': StreemApiSizeToJSON(value.expectedSizeMeters),
    };
}
//# sourceMappingURL=StreemRoomArTrackableDefinitionMarker2d.js.map